import { AMOUNT_FILTER_KEYS } from "modules/common/types/filters";
import { createAmountFilterSchema } from "modules/common/utils/amountFilterSchema";
import { getLastWeekDateRange } from "modules/common/utils/getLastWeekDateRange";
import * as Yup from "utils/yup";

const { start, end } = getLastWeekDateRange();

export const FILTERS_KEYS = {
  ...AMOUNT_FILTER_KEYS,
  STATUS: "status",
  TYPE: "type",
  CURRENCY: "currency",
  START_DATE: "startDate",
  END_DATE: "endDate",
} as const;

export const DEFAULT_FILTERS = {
  [FILTERS_KEYS.STATUS]: [],
  [FILTERS_KEYS.TYPE]: [],
  [FILTERS_KEYS.CURRENCY]: [],
  [FILTERS_KEYS.AMOUNT_FROM]: null,
  [FILTERS_KEYS.AMOUNT_TO]: null,
  [FILTERS_KEYS.START_DATE]: null,
  [FILTERS_KEYS.END_DATE]: null,
};

export const DEFAULT_FILTERS_CONFIGURATION = {
  [FILTERS_KEYS.STATUS]: {
    array: true as const,
    defaultValue: [],
  },
  [FILTERS_KEYS.TYPE]: {
    array: true as const,
    defaultValue: [],
  },
  [FILTERS_KEYS.CURRENCY]: {
    array: true as const,
    defaultValue: [],
  },
  [FILTERS_KEYS.AMOUNT_FROM]: {
    array: false,
    defaultValue: null,
  },
  [FILTERS_KEYS.AMOUNT_TO]: {
    array: false,
    defaultValue: null,
  },
  [FILTERS_KEYS.START_DATE]: {
    array: false,
    defaultValue: null,
  },
  [FILTERS_KEYS.END_DATE]: {
    array: false,
    defaultValue: null,
  },
};

export const FILTERS_SCHEMA = Yup.object().shape({
  ...createAmountFilterSchema(),
});

export const INITIAL_FILTERS_CONFIGURATION = Object.assign(
  {},
  DEFAULT_FILTERS_CONFIGURATION,
  {
    [FILTERS_KEYS.START_DATE]: {
      array: undefined,
      defaultValue: start.toISODate(),
    },
    [FILTERS_KEYS.END_DATE]: {
      array: undefined,
      defaultValue: end.toISODate(),
    },
  }
);
